import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useAuthContext } from '../auth/hooks';

const UserInfo = ({ sx }) => {
  const { user } = useAuthContext();

  return (
    <Box sx={sx}>
      <Typography variant="subtitle2" noWrap>
        {user?.name}
      </Typography>

      <Typography variant="body2" sx={{ opacity: 0.7 }} noWrap>
        {user?.email}
      </Typography>
    </Box>
  );
};

export default UserInfo;

UserInfo.propTypes = {
  sx: PropTypes.object,
};
